<template>
  <!-- Always rendered (never inside a v-if) so screen readers announce
       updates: a live region inserted into the DOM together with its first
       message is not announced by most assistive tech. Pass '' when idle. -->
  <span class="sr-only" role="status" aria-live="polite">{{ message }}</span>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: '',
  },
})
</script>
